import ENV from "config/Env";
import { typedQueryClient, useTypedMutation } from "hooks";
import { CommunicationTemplatesQueryKeys } from "modules/CommunicationTemplates/queryKeys";
import { ApiInstance } from "utils/Api";

export const useDeleteMediumMutation = () =>
  useTypedMutation<number, void>({
    mutationFn: async communication_medium_id => (await ApiInstance.post("/communication/mediums/delete", { communication_medium_id }, ENV.dealerBaseURL)).data,
    onSuccess: communication_medium_id => {
      const mediums = typedQueryClient.getQueryData(CommunicationTemplatesQueryKeys.getCommunicationMediums);
      if (!mediums?.length) return;

      const mediumIdx = mediums.findIndex(medium => medium.communication_medium_id === communication_medium_id);
      if (mediumIdx < 0) return;

      typedQueryClient.setQueryData(CommunicationTemplatesQueryKeys.getCommunicationMediums, mediums.toSpliced(mediumIdx, 1));
    }
  });
